// extracted by mini-css-extract-plugin
module.exports = {"socialShareLinks":"SocialShareLinks_socialShareLinks__ZRZd4","socialLink":"SocialShareLinks_socialLink__D9czI","mobile":"SocialShareLinks_mobile__pzqHn"};